import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { ROLE_TYPE } from '../../constants/roles';
import { PAGE_ROUTES } from '../../constants/pageRoutes';
import { PROPERTY_ICON, RENTAL_ICON } from '../../constants/images';

const mapStateToProps = state => ({
  registration: state.Registration
});

class CreateAccount extends Component {
  constructor(props) {
    super(props);

    const { userType } = this.props.registration.formData;
    this.state = {
      signingAsRenter: !userType || userType === ROLE_TYPE.renter
    }

    this.getFormLink = this.getFormLink.bind(this);
  }

  getFormLink = () => {
    return this.state.signingAsRenter ? PAGE_ROUTES.RENTER_SIGN_UP_1 : PAGE_ROUTES.OWNER_SIGN_UP_1;
  }

  render() {
    return (
      <div className="main-container">
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section">
                <h1 className="title">Choose Role</h1>
                <p className="detail-text role-text">Welcome! Would you like to join us as a renter or a property owner?</p>
                <div className="signin-page">
                  <form className="form-section">
                    <div className="role-section">
                      <div className={`role-box${this.state.signingAsRenter ? ' active' : ''}`}
                        onClick={() => { this.setState({ signingAsRenter: true }) }}
                      >
                        <div className="role-content">
                          <div className="role-icon">
                            <img src={RENTAL_ICON} className="rental-image" alt="role" />
                          </div>
                          <div className="detail">
                            <h3 className="role-title">Renter</h3>
                            <p className="paragraph">Rentals in college towns and explore college town favorites</p>
                          </div>
                        </div>
                      </div>
                      <div className={`role-box${this.state.signingAsRenter ? '' : ' active'}`}
                        onClick={() => { this.setState({ signingAsRenter: false }) }}
                      >
                        <div className="role-content">
                          <div className="role-icon">
                            <img src={PROPERTY_ICON} className="property-image" alt="role" />
                          </div>
                          <div className="detail">
                            <h3 className="role-title">Property Owner</h3>
                            <p className="paragraph">List your property for free and gain access to an property platform.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="note-text">
                      <p className="pg-note"><span>Note:</span> You can always rent with CollegeWeekends.com as
                        an owner, and vice versa.</p>
                    </div>
                    <Link to={this.getFormLink()}>
                      <div className="signin-button">
                        <button type="button" className="btn primary">Next</button>
                      </div>
                    </Link>
                    <div className="no-account-detail">
                      <p className="account-text">Already have an account? <Link to={PAGE_ROUTES.LOGIN} className="signup-link">Sign In</Link></p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div >
    );

  }
}

export default withRouter(connect(mapStateToProps)(CreateAccount));
